// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LightbulbBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M22.5 29a1.5 1.5 0 0 1-1.5 1.5H11a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 0 1 1.5 1.5Zm5-16a11.44 11.44 0 0 1-4.396 9.044 1.533 1.533 0 0 0-.604 1.206v.25A2.5 2.5 0 0 1 20 26h-8a2.5 2.5 0 0 1-2.5-2.5v-.25a1.5 1.5 0 0 0-.588-1.189A11.447 11.447 0 0 1 4.5 13.065C4.466 6.836 9.5 1.65 15.724 1.5A11.5 11.5 0 0 1 27.5 13Zm-3 0a8.5 8.5 0 0 0-8.706-8.5c-4.599.11-8.319 3.944-8.294 8.547a8.464 8.464 0 0 0 3.262 6.65A4.483 4.483 0 0 1 12.5 23h7.012a4.517 4.517 0 0 1 1.738-3.314A8.461 8.461 0 0 0 24.5 13Zm-2.509-.665a6.062 6.062 0 0 0-3.988-5 1.5 1.5 0 0 0-1 2.827 3.04 3.04 0 0 1 2.01 2.5 1.5 1.5 0 0 0 2.983-.33l-.005.003Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
